import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Box, Toolbar, Typography } from '@mui/material';
import More from '../Component/More';
import Footer from '../Component/Footer';
import DesktopFooter from "../Component/Desktopfooter";
import Header from "../Component/header";
const Sidebar = () => {
    const { t } = useLanguage();
    return (
        <>
            <div className='text-Wrapper'>
              <Header/>
                <Box>
                    <Toolbar>
                        <More />
                    </Toolbar>
                </Box>

            </div>
             <DesktopFooter/>
            <Footer />
        </>

    );
};

export default Sidebar;